import React from "react";
import Footer from "../components/layout/Footer";
import Navbar from "../components/layout/Navbar";

function Contact() {
  return (
    <div class="main-container">
      <Navbar />
      <div class="col-12 col-lg-5 ml-auto mr-auto contact-top">
        <h2 class="text-center">Contactez-nous</h2>
        <p class="text-center d-none d-md-block">
        Vous recherchez un plan plus personnalisé pour votre entreprise ? <br />
        Envoyez-nous un message et nous vous contacterons bientôt.
        </p>
        <div class="col-12 d-flex contact-list">
          <div class="col-lg-4 p-0 d-none d-md-block">
            <div class="mb-5">
              <h6>Téléphone</h6>
              <p class="mb-0">+2250710006109</p>
              <p>+2250710006109</p>
            </div>

            <div class="mb-4">
              <h6>Adresse</h6>
              <p class="mb-0">Abidjan,</p>
              <p>Côte d'Ivoire.</p>
            </div>

            <h6>Sociale</h6>
            <div class="social-icons mb-3">
              <div class="d-flex mb-2">
                <a href="https://twitter.com/ghanawifi" target="_blank">
                  <i class="fa fa-twitter"></i>
                </a>
              </div>

              <div class="d-flex mb-2">
                <a href="https://facebook.com/ghanawifi" target="_blank">
                  <i class="fa fa-facebook"></i>
                </a>
              </div>

              <div class="d-flex mb-2">
                <a href="https://instagram.com/ghanawificom" target="_blank">
                  <i class="fa fa-instagram"></i>
                </a>
              </div>

              <div class="mr-auto links">
                <a
                  href="https://linkedin.com/company/ghanawifi"
                  target="_blank"
                >
                  <i class="fa fa-linkedin-square"></i>
                </a>
              </div>
            </div>
          </div>
          <div class="col-lg-8 col-11 m-auto p-0">
            <form method="POST" class="form-horizontal">
              <div class="form-group">
                <div class="mb-3">
                  <label>Nom et prénom</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Nom et prénom"
                    v-model="Nom et prénom"
                  />
                </div>

                <div class="mb-3">
                  <label>Nom de l'entreprise</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Nom de l'entreprise"
                    v-model="Nom de l'entreprise"
                  />
                </div>

                <div class="mb-3">
                  <label>Email</label>
                  <input
                    type="E-mail"
                    class="form-control"
                    placeholder="E-mail"
                    name="email"
                    v-model="Email"
                  />
                </div>
                <div class="mb-3">
                  <label>Numéro de téléphone</label>
                  <input
                    type="tel"
                    class="form-control"
                    placeholder="Numéro de téléphone"
                    v-model="Numéro de téléphone"
                  />
                </div>

                <div class="mb-3"></div>

                <div class="mb-3">
                  <label>Adresse physique</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Adresse physique"
                    v-model="Adresse"
                  />
                </div>

                <div class="mb-3">
                  <label>Message</label>
                  <textarea
                    cols="200"
                    rows="4"
                    class="form-control"
                    placeholder="Message"
                    v-model="Message"
                  ></textarea>
                </div>

                <div>
                  <p class="check-sec">
                    <b>J'aimerais être contacté par :</b>
                  </p>
                  <input
                    type="checkbox"
                    class="mr-2"
                    v-model="hasphone"
                    value="phoneContact"
                  />{" "}
                  Téléphone
                  <br />
                  <input
                    type="checkbox"
                    class="mr-2"
                    v-model="hasemail"
                    value="emailContact"
                  />{" "}
                  E-mail
                </div>
                <div class="wrapper-button text-center">
                  <input
                    class="btn signup-btn w-100 text-white"
                    role="button"
                    value="ENVOYER"
                    type="submit"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Contact;
